import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Provider } from "react-redux";
import store from "./reducers/store";

var req = new XMLHttpRequest();
req.open("GET", document.location, false);
req.send(null);
var headers = req.getAllResponseHeaders();

//  alert(JSON.stringify(localStorage));
if (!localStorage.webKey)
{
    // localStorage.setItem("webKey","aTIwZ2xlUlVwdERoSmFGTmFCdnVxb2ZodFdYaUJJOTBsV1pXTzNDTkdWRk5qVkJ4YkFxTWlob01mYXYvTzR2Mg==")
    // window.location.href='/'
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

    <Provider store={store}>
      <App />
    </Provider>

);
